import { Component, OnInit, inject } from '@angular/core';
import { SzamlazzhuService } from 'src/app/services/szamlazzhu/szamlazzhu.service';
import { LoadingScreenComponent } from '../../../shared/loading-screen/loading-screen.component';

@Component({
  selector: 'app-szamlazzhu-sso',
  templateUrl: './szamlazzhu-sso.component.html',
  styleUrls: ['./szamlazzhu-sso.component.scss'],
  imports: [LoadingScreenComponent],
})
export class SzamlazzhuSsoComponent implements OnInit {
  private szamlazzhuService = inject(SzamlazzhuService);

  async ngOnInit() {
    await this.szamlazzhuService.redirectToSzamlazzhuLogin();
  }
}
